import React from 'react';
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";
import ViewTextGenericIndicators from '../generic-component/ViewTextGenericIndicators';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '90%', // Más responsivo
    maxWidth: '600px',
    maxHeight: '90vh',
    overflowY: 'auto',
    padding: '30px',
    borderRadius: '12px'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 1000
  }
};

Modal.setAppElement('#root');

const L5ModalTechnology = ({ modalIsOpen, closeModal, data, moduleSelected }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Previsualizar Tecnología"
    >
      <div className="modal-header-custom d-flex justify-content-between align-items-center mb-4">
        <h4 className="m-0 font-weight-bold">{t('general.title-modal-technology')}</h4>
        <button onClick={closeModal} className="btn-close" style={{border: 'none', background: 'none', fontSize: '1.5rem'}}>&times;</button>
      </div>

      <div className="container-fluid p-0">
        <div className="row mb-3">
          <div className="col-12 mb-2">
            <span className="text-muted small d-block">{t("technology.short.code")}</span>
            <strong className="text-dark">{data.code || 'N/A'}</strong>
          </div>
          
          <div className="col-12 mb-2">
            <span className="text-muted small d-block">{t("technology.short.name")}</span>
            <strong className="text-dark">{data.name}</strong>
          </div>

          <div className="col-12">
            <span className="text-muted small d-block">{t("technology.short.purpose")}</span>
            <p className="text-justify mb-0" style={{fontSize: '0.9rem', lineHeight: '1.4'}}>
              {data.purpose}
            </p>
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-12">
            <ViewTextGenericIndicators 
              values={data} 
              occupation={12} 
              moduleKey={moduleSelected?.key}
              tooltipPlace="right" //"top", "bottom", "right"
              />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default L5ModalTechnology;
